import React from "react";
import Header from "./layout/header";
import Footer from "./layout/footer";
import ServiceAIBanner from "./service-AI-banner";
import ServiceAIInfo from "./service-ai-info";
function ServiceAI() {
  return (
    <>
<Header/>
<main>
   <ServiceAIBanner/>
<ServiceAIInfo/>
</main>
<Footer/>
</>
  );
}

export default ServiceAI;
